/**
 * Banner
 * @author ftgibran
 */
import {ID, Resource} from 'simpli-web-sdk'

export default class ConfigEmailRegraEnvio extends Resource {
  static readonly NOTA_FISCAL = 1
  static readonly CTE = 1

  readonly $name: string = 'ConfigEmailRegraEnvio'

  readonly $endpoint: string = '/user/config-email/config-email-regra-envio'

  idConfigEmailRegraEnvioPk: number = 1

  descricao: string | null = null

  ativo: boolean | null = false

  get $id() {
    return this.idConfigEmailRegraEnvioPk
  }

  set $id(val: number) {
    this.idConfigEmailRegraEnvioPk = val
  }
}
